export default "__VITE_ASSET__ff83e01c__"